import React from "react";
import { Link } from "../../molecules/Link";

export const EstudianteSidebar = (props) => {
  return (
    <nav
      id={"sidebar"}
      className={"flex flex-col min-w-[13rem] min-h-screen bg-theme-blue text-white"}

    >
      <Link route={"/estudiantes"}>{"Lista de estudiantes"} </Link>
      <Link route={"/estudiantes/registrar"}>{"Registrar estudiantes"}</Link>
      <Link route={"/estudiantes/registro-masivo"}>{"Registro Masivo"}</Link>
      <Link route={"/estudiantes/congelados"}>{"Lista de congelados"}</Link>
      <Link route={"/estudiantes/EstudiantesReprobados"}>{"Lista de Reprobados"}</Link>
      <Link route="/estudiantes/descongelar">{"Descongelar Estudiantes"}</Link>
      <Link route="/estudiantes/activos">{"Estudiantes Activos"}</Link>
      <div className="mt-auto pt-4 border-t border-blue-400/30">
        <Link route="/estudiantes/cierre-gestion">
          <span className="text-xs opacity-70 hover:opacity-100">⚙️ Cierre de Gestión</span>
        </Link>
      </div>
      {/* <Link route={"/registro"}>{"Inscribir a modulos"}</Link> */}
    </nav>
  );
};
